export default "__VITE_ASSET__yywEPHzT__"